<div class="folder-tree-page">
  <div class="folder-card" [class.folder-card-embedded]="!showHeader">
    <div class="folder-card-header" [class.folder-card-header-compact]="!showHeader">
      <div *ngIf="showHeader">
        <span class="gpd-config-section-title" i18n="@@folderStructure">Folder structure</span>
        <p class="gpd-config-section-description">{{ folderStructureDescription }}</p>
      </div>
      <app-gpd-button
        type="primary"
        icon="add"
        i18n-text="@@addNewFolder"
        text="Create folder"
        (onClick)="addTopLevelFolder()"
      ></app-gpd-button>
    </div>

    <app-validation-toast
      *ngIf="showHeader"
      [inline]="true"
      [persistent]="true"
      [state]="'Info'"
      [autoTitle]="hintTitle"
      [autoMessage]="hintMessage"
    ></app-validation-toast>

    <dx-tree-list
      id="folder-tree"
      keyExpr="id"
      [dataSource]="treeData"
      dataStructure="tree"
      itemsExpr="subFolders"
      [autoExpandAll]="true"
      [expandedRowKeys]="expandedKeys"
      [showColumnHeaders]="false"
      [showBorders]="false"
      [hoverStateEnabled]="true"
      class="folder-tree-list"
    >
      <dxi-column dataField="name" cellTemplate="nameTemplate"></dxi-column>
      <div *dxTemplate="let item of 'nameTemplate'" class="folder-row">
        <app-svg-icon icon="folder" [size]="16" class="folder-icon"></app-svg-icon>
        <span class="folder-name">{{ item.data.name }}</span>
        <span class="folder-row-actions gpd-table-actions" *ngIf="!item.data.isVirtualRoot">
          <app-svg-icon icon="add" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" [attr.title]="addSubFolderText" (click)="$event.stopPropagation(); addSubFolder(item.data)"></app-svg-icon>
          <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" [attr.title]="editFolderText" (click)="$event.stopPropagation(); renameFolder(item.data)"></app-svg-icon>
          <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" [attr.title]="deleteHint" (click)="$event.stopPropagation(); initFolderDelete(item.data)"></app-svg-icon>
        </span>
      </div>
    </dx-tree-list>

    <div class="special-folder-section" *ngIf="!isSandbox">
      <div class="special-folder-row">
        <label class="special-folder-label">
          <ng-container *ngIf="isSite" i18n="@@propertyFolder">Property folder</ng-container>
          <ng-container *ngIf="!isSite" i18n="@@imagesFolder">Images folder</ng-container>
          <span class="required-marker">*</span>
          <span class="help-wrapper">
            <app-svg-icon icon="help" [size]="16" class="help-icon"></app-svg-icon>
            <span class="help-tooltip">{{ isSite ? pickerTooltipSite : pickerTooltipProject }}</span>
          </span>
        </label>
        <dx-select-box
          class="special-folder-picker"
          [dataSource]="flatFolders"
          valueExpr="id"
          displayExpr="path"
          [value]="pickerValue"
          [showClearButton]="true"
          (onValueChanged)="onPickerChanged($event)"
        ></dx-select-box>
      </div>
      <div class="special-folder-row" *ngIf="!isSite">
        <label class="special-folder-label">
          <ng-container i18n="@@commentsFolder">Comments folder</ng-container>
          <span class="help-wrapper">
            <app-svg-icon icon="help" [size]="16" class="help-icon"></app-svg-icon>
            <span class="help-tooltip">{{ pickerTooltipComments }}</span>
          </span>
        </label>
        <dx-select-box
          class="special-folder-picker"
          [dataSource]="flatFolders"
          valueExpr="id"
          displayExpr="path"
          [value]="commentsPickerValue"
          [showClearButton]="true"
          (onValueChanged)="onCommentsPickerChanged($event)"
        ></dx-select-box>
      </div>
      <div class="special-folder-row" *ngIf="!isSite && mastrEnabled">
        <label class="special-folder-label">
          <ng-container i18n="@@mastrFolder">MaStR folder</ng-container>
          <span class="help-wrapper">
            <app-svg-icon icon="help" [size]="16" class="help-icon"></app-svg-icon>
            <span class="help-tooltip">{{ pickerTooltipMastr }}</span>
          </span>
        </label>
        <dx-select-box
          class="special-folder-picker"
          [dataSource]="flatFolders"
          valueExpr="id"
          displayExpr="path"
          [value]="mastrPickerValue"
          [showClearButton]="true"
          (onValueChanged)="onMastrPickerChanged($event)"
        ></dx-select-box>
      </div>
    </div>


  </div>
</div>

<!-- add / rename popup -->
<app-generic-popup
  [(visible)]="editPanelVisible"
  [title]="currentPanelTitle"
  [width]="'420px'"
  [allowOutsideClick]="false"
  [buttons]="folderFormButtons"
>
  <div class="folder-name-field">
    <label class="folder-name-label" i18n="@@folderNameLabel">Name <span class="required-marker">*</span></label>
    <dx-text-box
      [(value)]="selectedFolder.name"
      [showClearButton]="true"
      valueChangeEvent="keyup"
    ></dx-text-box>
  </div>
</app-generic-popup>

<!-- simple delete confirm -->
<app-generic-popup
  [visible]="deleteMode === 'simple'"
  (visibleChange)="cancelDelete()"
  i18n-title="@@deleteFolderTitle"
  title="Delete folder"
  [width]="420"
  [allowOutsideClick]="false"
  [buttons]="deletePopupButtons"
>
  <p>{{ deleteConfirmPrefix }} <strong>{{ selectedFolder?.name }}</strong>{{ deleteConfirmSuffix }}</p>
</app-generic-popup>

<!-- type-name delete confirm (documents exist, no dependent tasks) -->
<app-generic-popup
  [visible]="deleteModeIsTypeName"
  (visibleChange)="cancelDelete()"
  i18n-title="@@deleteFolderTitle"
  title="Delete folder"
  [width]="480"
  [allowOutsideClick]="false"
  [buttons]="typeNameDeleteButtons"
>
  <p>{{ deleteTypeNameConfirmPrefix }} <strong>{{ selectedFolder?.name }}</strong>{{ deleteTypeNameConfirmSuffix }}</p>
  <app-validation-toast
    class="type-name-intro"
    [inline]="true"
    [persistent]="true"
    [state]="'Info'"
    autoMessage="This removes the folder from the template only. All existing projects and their documents remain unchanged. Future projects will no longer include this folder."
    i18n-autoMessage="@@deleteFolderTypeNameIntro"
  ></app-validation-toast>
  <div class="type-name-field">
    <label class="type-name-label" i18n="@@typeFolderNameToConfirm">Type the folder name to confirm:</label>
    <dx-text-box [(value)]="typedFolderName" valueChangeEvent="keyup"></dx-text-box>
  </div>
</app-generic-popup>

<!-- blocked dialog (dependent tasks) -->
<app-generic-popup
  [visible]="deleteModeIsBlocked"
  (visibleChange)="cancelDelete()"
  i18n-title="@@deleteFolderBlockedTitle"
  title="Folder is used by tasks"
  [width]="520"
  [allowOutsideClick]="true"
  [buttons]="blockedDeleteButtons"
>
  <p i18n="@@deleteFolderBlockedIntro">The following tasks save their documents in this folder:</p>
  <ul class="dependent-task-list">
    <li *ngFor="let task of deleteInfo.dependentTasks">{{ dependentTaskLabel(task) }}</li>
  </ul>
  <app-validation-toast
    class="blocked-instruction"
    [inline]="true"
    [persistent]="true"
    [state]="'Warning'"
    [htmlMessage]="blockedInstruction"
  ></app-validation-toast>
</app-generic-popup>

